import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, styled } from '@mui/material';
import { Text } from '../../atoms/typography';
import Button from '../../atoms/Button';
import { Logout } from '@mui/icons-material';
import useMediaQueries from '../../../hooks/useMediaQueries';
const Cell = styled(Box) `
  display: flex;
  padding: 8px var(--standard-spacing-x, 24px);
  &.desktop {
    width: 400px; // TODO: may need adjustment if we add more data cells
    border-left: 2px solid ${({ theme }) => theme.palette.divider};
  }
  &.tablet: {
    width: auto;
  }
  &.mobile {
    width: 100%;
    border-top: 2px solid ${({ theme }) => theme.palette.divider};
  }
`;
const DataCellTitle = styled(Text) `
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
`;
const DataCellValue = styled(Text) `
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
`;
;
const HeaderDataCell = ({ title, value, action }) => {
    const { fitForDesktop, fitForMobile, mediaClassNames } = useMediaQueries();
    const shouldTranslateValue = title === 'Company' ? 'no' : 'yes';
    return _jsx(Cell, { className: mediaClassNames, children: _jsxs(Box, { flex: 1, display: 'flex', children: [_jsxs(Box, { display: 'flex', flexDirection: fitForDesktop ? 'column' : 'row', flex: 1, columnGap: 1, justifyContent: !fitForMobile ? 'start' : 'space-between', children: [_jsx(Box, { display: 'flex', flex: fitForDesktop ? 1 : 'none', justifyContent: 'start', alignItems: fitForDesktop ? 'end' : 'center', children: _jsx(DataCellTitle, { color: 'text.secondary', children: title }) }), _jsx(Box, { display: 'flex', flex: fitForDesktop ? 1 : 'none', justifyContent: 'start', alignItems: fitForDesktop ? 'start' : 'center', children: _jsx(DataCellValue, { translate: shouldTranslateValue, children: value }) })] }), action?.icon && (_jsx(Box, { display: 'flex', flex: 1, justifyContent: 'end', alignItems: 'center', children: _jsx(Button, { variant: 'text', rightIcon: _jsx(Logout, {}), label: action.label, onClick: action.handler }) }))] }) });
};
export default HeaderDataCell;
//# sourceMappingURL=index.js.map